<template>
  <v-container>
    <v-data-table :headers="headers" :items="items" :loading="loadingServerSide">
      <template v-slot:item="{ item }">
        <tr v-if="item.local">
          <td class="warning">
            {{ item.supplier_id }}-{{ item.stock_code }}
          </td>
          <td class="warning">
            {{ item.product_name }}
          </td>
          <td class="warning">
            {{ item.quantity }} {{ item.unit }}
          </td>
          <td class="warning">
            {{ item.retail }}
          </td>
          <td class="warning" style="text-align: right">
            {{ formatMoney(item.discount) }}
          </td>
          <td class="warning" style="text-align: right">
            {{ formatMoney(lineAmount(item)) }}
          </td>
          <td class="warning">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mx-2" text dark x-small v-bind="attrs" color="red" v-on="on"
                       @click="removeFromTempList(item.index)">
                  <v-icon dark>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </tr>
        <tr v-else>
          <td>{{ item.supplier_id }}-{{ item.stock_code }}</td>
          <td>{{ item.product_name }}</td>
          <td>{{ item.quantity }} {{ item.unit }}</td>
          <td>{{ item.retail }}</td>
          <td style="text-align: right">
            {{ formatMoney(item.discount) }}
          </td>
          <td style="text-align: right">
            {{ formatMoney(lineAmount(item)) }}
          </td>
          <td>
            <return-product-btn
              :consumer-loan-inventory-id="item.id"
              :returned-product-id="item.returned_product_id"
              @click="onReturnProduct"
            />
            <v-tooltip v-if="authPermissions.has('consumer_loans:edit')" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mx-2" text dark x-small v-bind="attrs" color="yellow darken-3" v-on="on"
                       @click="editLoan(item)">
                  <v-icon dark>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="authPermissions.has('consumer_loans:delete')" class="mx-2" text dark x-small v-bind="attrs" color="red" v-on="on"
                       @click="remove(item.id)">
                  <v-icon dark>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
      <template v-slot:[`body.append`]>
        <tr>
          <th colspan="5">
            <span class="primary--text">Total Debt</span>
          </th>
          <td style="text-align: right">
            {{ formatMoney(totalDebt) }}
          </td>
          <td />
        </tr>
      </template>
    </v-data-table>

    <return-product-partial-create-dialog ref="returnDialog" />
  </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { moneyMixin } from '@/views/dashboard/mixins/helper.mixins'
import consumerLoanInventoryRepository from '@/repositories/consumer-loan-inventory.repository'
export default {
  name: 'IndexConsumerLoanInventory',
  components: {
    ReturnProductBtn: () => import('@/components/features/ReturnProductBtn.vue'),
    ReturnProductPartialCreateDialog: () => import('@/components/features/ReturnProductPartialCreateDialog.vue'),
  },
  props: {
    propConsumerId: String,
    propConsumerLoanId: String,
  },
  data() {
    return {
      headers: [
        { text: 'Stock Code', sortable: false },
        { text: 'Name' },
        { text: 'Quantity', value: 'quantity' },
        { text: 'Price', value: 'retail' },
        { text: 'Discount', value: 'discount' },
        { text: 'Total Amount', sortable: false },
        { text: 'Config', sortable: false },
      ],
      serverSideList: [],
      loadingServerSide: false,
    }
  },
  created() {
    this.getLoanInventory()
    this.initWebsocketEvents()
  },
  computed: {
    ...mapState({
      localList: state => state.consumerLoanInventory.tempList,
      consumerLoanInventoryUpdate: state => state.consumerLoanInventory.channelUpdate,
      authPermissions: state => state.auth.userPermissions,
    }),
    computedLocalList() {
      return this.localList
        .filter(e => e.consumer_loan_id === this.propConsumerLoanId)
        .map((e, index) => {
          return {
            ...e,
            local: true,
            index,
          }
        })
    },
    totalDebt() {
      return this.items.reduce((t, c) => t + this.lineAmount(c), 0)
    },
    items() {
      return this.computedLocalList.concat(this.serverSideList)
    },
  },
  watch: {
    consumerLoanInventoryUpdate() {
      this.getLoanInventory()
    },
  },
  methods: {
    ...mapActions({
      removeFromTempList: 'consumerLoanInventory/removeFromTempList',
    }),
    // Mirrors ConsumerLoanInventory::getAmountAttribute on the server
    lineAmount(item) {
      return (
        (Number(item.quantity) || 0) * (Number(item.retail) || 0) -
        (Number(item.discount) || 0)
      )
    },
    async getLoanInventory() {
      this.loadingServerSide = true
      const params = {
        consumer: this.propConsumerId,
        consumerLoan: this.propConsumerLoanId,
      }
      consumerLoanInventoryRepository.index(params)
        .then(({ data }) => { this.serverSideList = data })
        .catch(e => { })
        .then(() => { this.loadingServerSide = false })
    },
    // getLoanSuccess ({ data }) {
    //    = data.map(el => {
    //     const stock = el.stock
    //     delete el.stock
    //     delete el.supplier
    //     return {
    //       ...el,
    //       productName: stock.product_name,
    //     }
    //   })
    // },
    editLoan(item) {
      this.$emit('edit', item)
    },
    remove(id) {
      this.$confirm('Do you really want to delete this data?')
        .then(confirm => {
          if (!confirm) return
          this.deleteConsumerLoanInventory(id)
        })
    },
    deleteConsumerLoanInventory(id) {
      consumerLoanInventoryRepository.delete(id)
        .then()
    },
    async onReturnProduct(submitFn) {
      const dialog = this.$refs.returnDialog
      const result = await dialog.open()
      if (!result) return
      await submitFn(result)
      this.getLoanInventory()
    },

    initWebsocketEvents() {
      const { echo } = this.$store.state.websocket
      echo.channel('database-update')
        .listen('ConsumerLoanUpdated', this.getLoanInventory)
    },
  },
  mixins: [
    moneyMixin,
  ],
}
</script>
<style lang="scss" scoped>
.warning {
  background-color: #FBBC05;
}
</style>
